import React from "react";

import "../styles.scss";
import "../scripts";

import {
  primaryBlock,
  PrimaryBlockConfig,
  getDefaultProps,
  KameleonElement,
  SecondaryBlockSize,
  TertiaryBlockSize,
  BlockTheme,
  BlockType,
  Shared,
} from "@kameleon-core/lib";
import { Variants } from "@kameleon-util/global-theme";
import { Box, Paragraph } from "theme-ui";

import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { FormType, layoutOptions } from "./types/prop-types";

/** Form Primary */
const blockConfig: PrimaryBlockConfig = {
  secondaryBlockSize: SecondaryBlockSize.None,
  tertiaryBlockSize: TertiaryBlockSize.None,
  blockType: BlockType.Primary,
  blockTheme: BlockTheme.light,
};

const { Form } = Shared.Components;

export const FormComponent = primaryBlock<FormType>(
  blockConfig,
  ({
    tagline,
    title,
    description,
    image,
    inputs,
    checkbox,
    submitButton,
    submitMsgSuccess,
    submitMsgError,
    onSubmit,
    layoutProps,
  }: FormType) => {
    const mediaIsRight = layoutProps.mediaPlacement === "right";

    return (
      <Box className="primary-form-tall-image-v1">
        <Box className="padding-global">
          <Box className="container-large">
            <Box className="padding-section-large">
              <Box className="contact7_component">
                <Box
                  sx={{ order: mediaIsRight ? -1 : 1 }}
                  className="contact7_content"
                >
                  <Box className="margin-bottom margin-medium">
                    {tagline && (
                      <Box className="margin-bottom margin-xsmall">
                        <Variants.TagLine>{tagline}</Variants.TagLine>
                      </Box>
                    )}
                    <Box className="margin-bottom margin-small">
                      <Variants.Heading as="h2">{title}</Variants.Heading>
                    </Box>
                    <Paragraph>{description}</Paragraph>
                  </Box>
                  <Form
                    className="contact7_form-block w-form"
                    inputs={inputs}
                    checkbox={checkbox}
                    submitButton={submitButton}
                    submitMsgSuccess={submitMsgSuccess}
                    submitMsgError={submitMsgError}
                    onSubmit={onSubmit}
                    formClassName="contact7_form"
                  />
                </Box>
                <Box className="contact7_image-wrapper">
                  <Variants.Image
                    src={image.url}
                    alt={image.alt}
                    className="contact_hm_image"
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }
);

FormComponent.defaultProps = getDefaultProps<FormType>(defaults);

export const Element: KameleonElement = {
  component: FormComponent,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
